import { getClaims } from "@/client/services/user";

export const getSession = async () => {
  try {
    const claims = await getClaims();

    if (!claims) {
      return null;
    }

    // Return data in the format expected by existing code
    return {
      user: {
        id: claims.sub,
        email: claims.email,
        phone: claims.phone,
        role: claims.role,
        app_metadata: claims.app_metadata ?? {},
        user_metadata: claims.user_metadata ?? {},
        aal: claims.aal,
        amr: claims.amr,
        session_id: claims.session_id,
        is_anonymous: claims.is_anonymous ?? false,
      },
      session: {
        access_token: null, // No longer needed with getClaims
        refresh_token: null, // No longer needed with getClaims
      },
    };
  } catch {
    return null;
  }
};
